import React from 'react';
import classNames from 'classnames';
import { getAppName } from '../../selectors/appRuntimeReader';
import { useLibraryTranslations } from '../../context/TranslationsContext';
import { useInstallerContext } from '../../context/InstallerContext';
export const ProgressBarLoader = function (_temp) {
  let {
    text: textProp,
    remove: removeProp,
    duration = 8
  } = _temp === void 0 ? {} : _temp;
  const {
    preInstallationData: {
      app,
      isAppAlreadyInstalled
    },
    isFinishedLoading
  } = useInstallerContext();
  const {
    t
  } = useLibraryTranslations();
  const appName = getAppName(app);
  const remove = removeProp || isFinishedLoading;
  const text = textProp || t('install-loader.text', {
    appName,
    isAppAlreadyInstalled: String(isAppAlreadyInstalled)
  });
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("style", null, progressBarStyle), /*#__PURE__*/React.createElement("div", {
    className: "container"
  }, /*#__PURE__*/React.createElement("div", {
    "data-hook": "progress-bar",
    className: "progressBar"
  }, /*#__PURE__*/React.createElement("div", {
    "data-hook": "progress-bar-fill",
    className: classNames('progressBarFill', {
      remove
    }),
    style: {
      '--loader-duration': `${duration}s`
    }
  })), /*#__PURE__*/React.createElement("div", {
    "data-hook": "loader-text",
    className: "loaderMessage",
    id: "loader-message"
  }, text)));
};
const progressBarStyle = `
@font-face {
font-family: madefor;
src: url(https://static.parastorage.com/unpkg/@wix/wix-fonts@1.11.0/media/WixMadeforTextVF_W_Wght.8022447a.woff2) format("woff2");
}
html, body {
  height: 100%;
  margin:0;
}
.container {
  margin: 0;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap:28px;
  .progressBar {
    width: 352px;
    height: 6px;
    background: var(--wsr-color-D10-10,#E5E6E9);
    border-radius: 6px;
    overflow: hidden;
    .progressBarFill {
      width: 100%;
      height: 100%;
      background-image: linear-gradient(to right, #A8CAFF, #116DFF);
      will-change: transform;
      animation: var(--loader-duration, 8s) forwards fakeProgress cubic-bezier(.16,-0.01,.22,1.02);
      overflow: hidden;
      &::after {
        content: "";
        width: 40%;
        height: 100%;
        opacity: 0.6;
        position: absolute;
        top: 0;
        left: -15%;
        background: linear-gradient(to right, transparent 0%, #fff 40%, #fff 60%, transparent 100%);
        animation: progressBarAnimation 1.6s ease 0.4s infinite;
      }
      &.remove {
          animation-name: moveToComplete;
      }
    }
  }
  .loaderMessage{
    font-family: madefor;
    font-size: 14px;
    white-space: nowrap;
  }
}

@keyframes moveToComplete {
  100% {
    transform: translateX(0%);
  }
}

@keyframes fakeProgress {
  0% {
    transform: translateX(-100%);
  }

  100% {
    transform: translateX(-2%);
  }
}
@keyframes progressBarAnimation {
  0% {
    left: -15%;
  }
  100% {
    left: 100%;
  }
}
`;
//# sourceMappingURL=ProgressBarLoader.js.map